<template>
  <div
    class="flex items-center justify-center"
    style="height: 100%">
    <vs-button
      v-if="params.data"
      class="btnx"
      size="small"
      type="filled"
      @click="sendMessage">
    {{ $t('ButtonText') }}
    </vs-button>
  </div>
</template>

<script>
export default {
  name: 'WaitingListCellRendererActions',
  i18n: {
    messages: {
      en: {
        ButtonText: 'Send message',
      },
    },
  },
  methods: {
    sendMessage() {
      this.params.context.componentParent.waitingListToSendMessage = this.params.data;
    },
  },
};
</script>
